import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import BattlePassBar from './BattlePassBar';
import { battlePassGamesPlayed, battlePassProgress, battlePassProgressText } from '../battlePass';

/**
 * The Battle Pass modal opened from the Arena tag page (see addArenaTab).
 * Centered intro line, then the viewer's progress in a pill badge, then the
 * level track itself (header hidden — the badge replaces it). For guests
 * the track renders from level 1 with no progress — the pass doubles as a
 * "what you can earn" showcase, which is exactly why the tag-page button
 * is visible to guests.
 */
export default class BattlePassModal extends Modal {
  className() {
    return 'ArenaBattlePassModal Modal--large';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-medal"
    }), ' ', app.translator.trans('forumaker-arena.forum.battle_pass.title'));
  }
  content() {
    const games = battlePassGamesPlayed(app.session.user);
    const progress = battlePassProgress(games);
    return m("div", {
      className: "Modal-body ArenaBattlePassModal-body"
    }, m("p", {
      className: "ArenaBattlePassModal-intro"
    }, app.translator.trans('forumaker-arena.forum.battle_pass.modal_intro')), m("div", {
      className: "ArenaBattlePass-progressBadge ArenaBattlePassModal-progressBadge"
    }, battlePassProgressText(progress)), m(BattlePassBar, {
      games: games,
      hideHeader: true
    }));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/BattlePassModal', BattlePassModal);